
import getRefs from '../core/ref/get-refs';

export default getRefs;
